// extracted by mini-css-extract-plugin
module.exports = {"total":"_3u1Xgx"};